/**
 * Created by Alex Xia on 1/15/2020.
 * Description:
 * ------ maintenance history ------
 */
import { Component, OnInit, Output, EventEmitter, ElementRef, OnDestroy, ViewChild, Input, ViewContainerRef, Renderer2, AfterViewInit, ChangeDetectionStrategy, ComponentRef } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { MapAction, MapConfig } from '../tam-dashboard-map/tam-dashboard-map.model';
import { AutocompleteActionType, MapContactModel } from '../tam-dashboard-map-autocomplete/tam-dashboard-map-autocomplete.model';
import { DynamicComponentService } from '../../../../services/dynamic-component.service';
import { TamDashboardMapTripAutocompleteComponent } from './map-trip-autocomplete/map-trip-autocomplete.component';
import { MapTripActionType, MapTripVehicleType } from './map-trip.model';
import { businessConstants } from '../../../../constants/business.constants';
import { ChangeDetectorRef } from '@angular/core';
import { MapTileService, TripAutocompleteActionType } from '@tamalelibs/services/maptile.service';
import { TamDashboardMapTileService } from '../tam-dashboard-map-tile.service';
import { TamDashboardTileData } from '../tam-dashboard-map-tile.config';

@Component({
    selector: 'tam-dashboard-map-trip',
    templateUrl: './map-trip.component.html',
    styleUrls: ['./map-trip.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TamDashboardMapTripComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() destinationConfig: MapContactModel;
    @Input() id: string;

    @Output() eventSubject$ = new EventEmitter<any>();
    @ViewChild('targetSearchAddress', { static: false }) searchAddress: ElementRef;
    @ViewChild('tripAutoCompleteContainer', { static: false, read: ViewContainerRef }) container: ViewContainerRef;
    @ViewChild('tripAddStopContainer', { static: false, read: ViewContainerRef }) addStopContainer: ViewContainerRef;

    showDetail = 'Show route details';
    hideDetail = 'Hide route details';
    addresss = '';
    anchor: ElementRef;
    contacts$: Observable<any>;
    destinationLat: number;
    destinationLng: number;
    directionArray: Array<string>;
    errorMessage = '';
    isBoxHoverOn = false;
    isBoxShow = true;
    isItemDetailShow = false;
    isPopUpShow = false;
    isShowNearby = false;
    isTransitDisabled = false;
    labelState = this.showDetail;
    mapConfig = new MapConfig();
    sourceConfig: MapContactModel = new MapContactModel();
    userInput = ''; // user search text
    vehicleType: string;
    routeData = null;

    private _componentRef: ComponentRef<any>;
    private _destroySubscriptions: Array<Subscription> = [];
    private _element: HTMLElement;
    private _subscribed = false;

    constructor(
        private elementRef: ElementRef,
        private _changeDetectorRef: ChangeDetectorRef,
        private renderer: Renderer2,
        private _mapTileService: MapTileService,
        private _dynamicComponentService: DynamicComponentService,
        private _tamDashboardMapTileService: TamDashboardMapTileService,
    ) {
        this._element = this.elementRef.nativeElement;
    }

    ngOnInit() {
        this._initSubscriptions();
    }

    ngAfterViewInit() {
        this._refreshTripAutocomplements();
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
        this._subscribed = false;
        if (this._componentRef) {
            this._componentRef.destroy();
        }
    }

    boxHoverOn() {
        this.isBoxHoverOn = true;
    }

    boxMouseOut() {
        this.isBoxHoverOn = false;
    }

    changeBoxStatus() {
        this.isBoxShow = !this.isBoxShow;
        this.isBoxHoverOn = false;
    }

    closeTripPanel() {
        this.eventSubject$.emit({ type: MapTripActionType.closeTripPanel, payload: null });
    }

    onClickAddTripAutocompleteCtrol(e: Event) {
        this._newTripAutocompleteComponent();
        this._clearErrorMessage();
        this._updateChangesToUI();
        this._refreshTripAutocomplements();
    }

    onClickGetDirection() {
        this.directionArray = [];
        this._clearErrorMessage();

        const inputElements = this._element.querySelectorAll('.textInput');
        if (inputElements && inputElements.length > 0) {
            inputElements.forEach((item: any) => {
                if (item['value']) {
                    this.directionArray.push(item['value']);
                }
            });
        }
        if (inputElements.length === this.directionArray.length) {
            this.eventSubject$.emit({ type: MapTripActionType.refreshTripDirections, payload: { vehicleType: this.vehicleType, directionArray: this.directionArray } });
        } else {
            // there were some empty autocomplete controls existed in this case
            this.errorMessage = businessConstants.mapTileErrorMessage.emptyAutocompleteError;
        }
        this._updateChangesToUI();
    }

    onClickDriveMode() {
        this.vehicleType = MapTripVehicleType.driving;
        this._setStyleByVehicleType(this.vehicleType);
    }

    onClickTransitMode() {
        if (!this.isTransitDisabled) {
            this.vehicleType = MapTripVehicleType.transit;
            this._setStyleByVehicleType(this.vehicleType);
        }
    }

    onClickWalkMode() {
        this.vehicleType = MapTripVehicleType.walking;
        this._setStyleByVehicleType(this.vehicleType);
    }

    onClickShowNearby(event) {
        this.eventSubject$.emit({
            type: AutocompleteActionType.searchNearby,
            payload: {
                content: event.payload,
                isTrip: true,
                isFromDirectionInput: event.isFromDirectionInput
            }
        });
    }

    /**
     * set status for expand route content
     *
     * @memberof TamDashboardMapTripComponent
     */
    showOrHideNavigateAddres(data, i) {
        this.routeData['legs'].forEach((item, index) => {
            if (i === index) {
                item.showRouteDetail = !item.showRouteDetail;
            }
        });
    }

    private _actionEventHandler(action) {
        if (action.type === TripAutocompleteActionType.LessThanTwoAutocompletes) {
            this.errorMessage = businessConstants.mapTileErrorMessage.removeAutocompleteError;
        } else if (action.type === TripAutocompleteActionType.ClearErrorMessage) {
            this._clearErrorMessage();
        } else if (action.type === TripAutocompleteActionType.RefreshTripMap) {
            this._refreshTripAutocomplements();
        } else if (action.type === TripAutocompleteActionType.ZERORESULTS) {
            this.errorMessage = businessConstants.mapTileErrorMessage.noResult;
        } else if (action.type === TripAutocompleteActionType.GETTRIP) {
            const data = action.payload;
            this.routeData = data.routes[0];
            this.routeData['legs'].forEach(item => {
                item['showRouteDetail'] = true;
            });
        }
        this._updateChangesToUI();
    }

    private _clearErrorMessage() {
        this.errorMessage = '';
    }

    private _initSubscriptions() {
        if (!this._subscribed) {
            this._subscribed = true;
            this._destroySubscriptions.push(
                this._mapTileService.tripAutoCompleteActionSubject$.subscribe(action => this._actionEventHandler(action)),
                this._tamDashboardMapTileService.feedbackSubject$.subscribe(res => {
                    if (this.id === res.id && res.type === MapAction.ADD_STOP) {
                        this.isBoxShow = true;
                        this.isShowNearby = true;
                        this._newStopRouterCompoent(res.payload);
                    }
                })
            );
        }
    }

    private _newTripAutocompleteComponent() {
        this._componentRef = this._dynamicComponentService.loadComponent<TamDashboardMapTripAutocompleteComponent>
            (this.container, TamDashboardMapTripAutocompleteComponent, false);
        this._componentRef.instance.config = {};
        // dynamic  Component  need use subscribe for output event.
        this._componentRef.instance.eventSubject$.subscribe(val => {
            this.onClickShowNearby(val);
        });
    }

    /**
     * also use TamDashboardMapTripAutocompleteComponent,but need set component below last router.
     *
     * @private
     * @memberof TamDashboardMapTripComponent
     */
    private _newStopRouterCompoent(data: TamDashboardTileData) {
        this._componentRef = this._dynamicComponentService.loadComponent<TamDashboardMapTripAutocompleteComponent>
            (this.addStopContainer, TamDashboardMapTripAutocompleteComponent, false);
        const _data = new MapContactModel();
        _data.latitude = data.latitude;
        _data.longitude = data.longitude;
        _data.selectedAddress = data.address;
        _data.selectedAddressType = data.addressType;
        _data.contact = data.detail;
        this._componentRef.instance.config = _data;
        // dynamic  Component  need use subscribe for output event.
        this._componentRef.instance.eventSubject$.subscribe(val => {
            this.onClickShowNearby(val);
        });
    }

    /**
     * Refresh the UI when adding new component or removing component
     */
    private _refreshTripAutocomplements() {
        const tripAutoCompletes = this._element.querySelectorAll('.trip_autocomplete_container');
        tripAutoCompletes.forEach(element => {
            this._setElementClass(element.querySelector('.direction-curve-line'), 'showItem', 'hideItem');
            this._setElementClass(element.querySelector('.direction-bluemark'), 'hideItem', 'showItem');
        });
        const lastElement = tripAutoCompletes[tripAutoCompletes.length - 1];
        if (lastElement) {
            this._setElementClass(lastElement.querySelector('.direction-curve-line'), 'hideItem', 'showItem');
            this._setElementClass(lastElement.querySelector('.direction-bluemark'), 'showItem', 'hideItem');
        }

        // set placeholder
        const tripAutoCompleteInputs = this._element.querySelectorAll('.textInput');
        if (tripAutoCompleteInputs) {
            for (let i = 0; i < tripAutoCompletes.length; i++) {
                if (i === 0) {
                    tripAutoCompleteInputs[i].setAttribute('placeholder', 'Enter Starting Point');
                } else if ((i === tripAutoCompletes.length - 1)) {
                    tripAutoCompleteInputs[i].setAttribute('placeholder', 'Enter Destination');
                } else {
                    tripAutoCompleteInputs[i].setAttribute('placeholder', 'Enter Stop Point');
                }
            }
        }

        // disable transit if the number of autocomplete is more than 2
        if (Array.from(tripAutoCompletes).length > 2) {
            this.renderer.addClass(this._element.querySelector('.trip-type-transit'), 'trip-type-transit-disabled');
            this.isTransitDisabled = true;
            if (this.vehicleType === MapTripVehicleType.transit) {
                this.onClickDriveMode();
            }
            // show close button
            const showControls = Array.from(this._element.querySelectorAll('.close-container'));
            showControls.forEach(element => {
                this.renderer.setStyle(element, 'visibility', 'visible');
            });
        } else {
            this.renderer.removeClass(this._element.querySelector('.trip-type-transit'), 'trip-type-transit-disabled');
            this.isTransitDisabled = false;
            // hide close button
            const hideControls = Array.from(this._element.querySelectorAll('.close-container'));
            hideControls.forEach(element => {
                this.renderer.setStyle(element, 'visibility', 'hidden');
            });
        }
    }

    private _setElementClass(element, classToAdd, classToRemove) {
        if (element && classToAdd && classToRemove) {
            this.renderer.removeClass(element, classToRemove);
            this.renderer.addClass(element, classToAdd);
        }
    }

    private _setSelectedStatus(style: string, isSelected: boolean) {
        if (isSelected) {
            this._setElementClass(this._element.querySelector(style), 'IconSelected', 'IconUnselected');
        } else {
            this._setElementClass(this._element.querySelector(style), 'IconUnselected', 'IconSelected');
        }
    }

    /**
     * only one vehicle can be selected
     */
    private _setStyleByVehicleType(type) {
        switch (type) {
            case MapTripVehicleType.driving:
                this._setSelectedStatus('.trip-type-drive', true);
                this._setSelectedStatus('.trip-type-transit', false);
                this._setSelectedStatus('.trip-type-walk', false);
                break;
            case MapTripVehicleType.transit:
                this._setSelectedStatus('.trip-type-drive', false);
                this._setSelectedStatus('.trip-type-transit', true);
                this._setSelectedStatus('.trip-type-walk', false);
                break;
            case MapTripVehicleType.walking:
                this._setSelectedStatus('.trip-type-drive', false);
                this._setSelectedStatus('.trip-type-transit', false);
                this._setSelectedStatus('.trip-type-walk', true);
                break;
            default:
                break;
        }
    }

    private _updateChangesToUI() {
        if (!this._changeDetectorRef[businessConstants.common.changeDetectorDestroyedIdentifier]) {
            this._changeDetectorRef.detectChanges();
        }
    }
}
